import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

interface IProps {
    content: string;
    isMe: boolean;
}

class MessageContent extends React.Component<IProps> {
    
    private markdownComponents = {
        p: ({ children }: any) => <p style={{ margin: '0 0 8px 0', lineHeight: 1.4 }}>{children}</p>,
        h1: ({ children }: any) => <h1 style={{ fontSize: 16, margin: '0 0 8px 0', fontWeight: 'bold' }}>{children}</h1>,
        h2: ({ children }: any) => <h2 style={{ fontSize: 15, margin: '0 0 6px 0', fontWeight: 'bold' }}>{children}</h2>,
        h3: ({ children }: any) => <h3 style={{ fontSize: 14, margin: '0 0 4px 0', fontWeight: 'bold' }}>{children}</h3>,
        ul: ({ children }: any) => <ul style={{ margin: '0 0 8px 16px', paddingLeft: 0 }}>{children}</ul>,
        ol: ({ children }: any) => <ol style={{ margin: '0 0 8px 16px', paddingLeft: 0 }}>{children}</ol>,
        li: ({ children }: any) => <li style={{ margin: '2px 0' }}>{children}</li>,
        code: ({ children, className }: any) => {
            const isInline = !className;
            return isInline ? (
                <code style={{
                    backgroundColor: 'rgba(0,0,0,0.1)',
                    padding: '2px 4px',
                    borderRadius: 3,
                    fontSize: 12,
                    fontFamily: 'BoschFont'
                }}>{children}</code>
            ) : (
                <pre style={{
                    backgroundColor: 'rgba(0,0,0,0.1)',
                    padding: 8,
                    borderRadius: 6,
                    fontSize: 11,
                    fontFamily: 'BoschFont',
                    overflow: 'auto',
                    margin: '4px 0'
                }}>
                    <code>{children}</code>
                </pre>
            );
        },
        blockquote: ({ children }: any) => (
            <blockquote style={{
                borderLeft: '3px solid #007BC0',
                paddingLeft: 8,
                margin: '4px 0',
                fontStyle: 'italic',
                color: '#666'
            }}>{children}</blockquote>
        ),
        table: ({ children }: any) => (
            <table style={{
                borderCollapse: 'collapse',
                width: '100%',
                margin: '8px 0',
                fontSize: 11
            }}>{children}</table>
        ),
        th: ({ children }: any) => (
            <th style={{
                border: '1px solid #ddd',
                padding: 4,
                backgroundColor: 'rgba(0,123,192,0.1)',
                fontWeight: 'bold'
            }}>{children}</th>
        ),
        td: ({ children }: any) => (
            <td style={{
                border: '1px solid #ddd',
                padding: 4
            }}>{children}</td>
        ),
        a: ({ children, href }: any) => (
            <a href={href} target="_blank" rel="noopener noreferrer" style={{
                color: '#007BC0',
                textDecoration: 'underline'
            }}>{children}</a>
        ),
        strong: ({ children }: any) => <strong style={{ fontWeight: 'bold' }}>{children}</strong>,
        em: ({ children }: any) => <em style={{ fontStyle: 'italic' }}>{children}</em>
    };

    render() {
        const { content, isMe } = this.props;

        if (isMe) {
            return <>{content}</>;
        }

        return (
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                components={this.markdownComponents}
            >
                {content}
            </ReactMarkdown>
        );
    }
}

export default MessageContent;